"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuInput = _interopRequireDefault(require("../elements/AuInput"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _constants = require("../../constants");
var _context2, _context3;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "multi_dropdown-module__container___TF964",
  "options": "multi_dropdown-module__options___JgZTM",
  "above": "multi_dropdown-module__above___hjq5A",
  "option_group": "multi_dropdown-module__option_group___RD6WH",
  "hide_options": "multi_dropdown-module__hide_options___NOiUD",
  "option_header": "multi_dropdown-module__option_header___fuLRt",
  "expanded": "multi_dropdown-module__expanded___t_btA",
  "disabled": "multi_dropdown-module__disabled___azLEM",
  "group_options_wrapper": "multi_dropdown-module__group_options_wrapper___zG42t",
  "group_expanded": "multi_dropdown-module__group_expanded___ta_3U",
  "hide_scrollbar": "multi_dropdown-module__hide_scrollbar___gOv7i",
  "option": "multi_dropdown-module__option___mbi0F",
  "selected": "multi_dropdown-module__selected___Q5oQY",
  "toggle": "multi_dropdown-module__toggle___uQT7l"
};
const DEFAULT_INDEX = -1;
const INTERACTIVE_KEYS = [_constants.DOWN_KEY, _constants.ENTER_KEY, _constants.UP_KEY];
const SELECTED = "MULTI_DROPDOWN_SELECTED_ITEM";
const MAX_DROPDOWN_HEIGHT = 400;
const objectsEqual = (o1, o2) => {
  var _context;
  if (o2 === null && o1 !== null) return false;
  return o1 !== null && typeof o1 === 'object' && (0, _keys.default)(o1).length > 0 ? (0, _keys.default)(o1).length === (0, _keys.default)(o2).length && (0, _every.default)(_context = (0, _keys.default)(o1)).call(_context, p => objectsEqual(o1[p], o2[p])) : o1 !== null && (0, _isArray.default)(o1) && (0, _isArray.default)(o2) && !o1.length && !o2.length ? true : o1 === o2;
};
class MultiDropDown extends _react.default.Component {
  static propTypes = {
    className: T.string,
    optionsClassName: T.string,
    selection: T.string,
    options: T.arrayOf(T.shape({
      displayId: T.string,
      displayString: T.string,
      options: T.arrayOf(T.shape({
        val: T.string,
        displayId: T.string,
        displayString: T.oneOfType([T.string, T.element, T.arrayOf(T.oneOfType([T.string, T.element]))])
      }))
    })),
    selectOption: T.func,
    onChange: T.func,
    onClear: T.func,
    allowTyping: T.bool,
    showError: T.bool,
    error: T.shape({
      fieldDisplayId: T.string,
      errDisplayId: T.string
    }),
    expandedPlaceholder: T.string,
    placeholder: T.string,
    expandedPlaceholderId: T.string,
    placeholderId: T.string
  };
  static defaultProps = {
    selection: "",
    onChange: _constants.NOOP,
    onClear: _constants.NOOP,
    options: [],
    selectOption: _constants.NOOP,
    allowTyping: false
  };
  constructor(props) {
    super(props);
    this.state = {
      showOptions: false,
      expandedOptionIndex: DEFAULT_INDEX,
      selectedIndex: DEFAULT_INDEX
    };
  }
  containerRef = /*#__PURE__*/_react.default.createRef();
  componentDidUpdate(prevProps) {
    if (this.props.options.length === 0 && this.state.showOptions) {
      return this.setState({
        showOptions: false,
        selectedIndex: DEFAULT_INDEX
      });
    }
    if (this.props.options.length === 1 && !this.state.showOptions) {
      return this.setState({
        showOptions: true,
        expandedOptionIndex: 0,
        selectedIndex: DEFAULT_INDEX,
        maxOptions: this.getOptionTotal({})
      });
    }
    if (!objectsEqual(this.props.options, prevProps.options)) {
      this.setState({
        showOptions: true,
        expandedOptionIndex: DEFAULT_INDEX,
        selectedIndex: DEFAULT_INDEX,
        maxOptions: this.getOptionTotal({})
      });
    }
  }
  onChange(value) {
    this.props.onChange(value);
    this.setState({
      showOptions: this.props.allowTyping ? true : false,
      selectedIndex: DEFAULT_INDEX
    });
  }
  selectOption = (0, _bind.default)(_context2 = this.selectOption).call(_context2, this);
  selectOption(value, groupName) {
    this.props.selectOption(value, groupName);
    this.setState({
      showOptions: false,
      selectedIndex: DEFAULT_INDEX
    });
  }
  expandOptionGroup = (0, _bind.default)(_context3 = this.expandOptionGroup).call(_context3, this);
  expandOptionGroup(idx) {
    if (this.state.expandedOptionIndex === idx) {
      const totalCollapsedOptionCount = this.getOptionTotal({});
      this.setState({
        expandedOptionIndex: DEFAULT_INDEX,
        selectedIndex: idx,
        maxOptions: totalCollapsedOptionCount
      });
    } else {
      this.setState({
        expandedOptionIndex: idx,
        selectedIndex: idx,
        maxOptions: this.getOptionTotal({
          expandedIndex: idx
        })
      });
    }
  }
  getOptionTotal({
    expandedIndex = DEFAULT_INDEX
  }) {
    var _context4;
    function getOptionsCount(totalOptionsInGroup, optionIndex) {
      if (expandedIndex === DEFAULT_INDEX) {
        return 0;
      }
      return expandedIndex === optionIndex ? totalOptionsInGroup : 0;
    }
    const maxOptions = (0, _reduce.default)(_context4 = this.props.options).call(_context4, (runningTotal, optionGroup, index) => {
      const headerCount = 1;
      const optionsCount = getOptionsCount(optionGroup.options.length, index);
      return runningTotal + headerCount + optionsCount;
    }, 0);
    return maxOptions;
  }
  onInteractiveKey(e) {
    if (e.key === _constants.ENTER_KEY) {
      return document.getElementById(SELECTED)?.click();
    }
    const {
      selectedIndex,
      maxOptions
    } = this.state;
    const nextIndex = e.key === _constants.UP_KEY ? Math.max(selectedIndex - 1, DEFAULT_INDEX) : Math.min(selectedIndex + 1, maxOptions - 1);
    e.preventDefault();
    this.setState({
      selectedIndex: nextIndex
    }, () => {
      const selectedElement = document.getElementById(SELECTED);
      selectedElement?.scrollIntoView();
    });
  }
  expandDropdown() {
    this.setState(prevState => ({
      showOptions: !prevState.showOptions
    }));
  }
  render() {
    const {
      createMode,
      className,
      selection,
      onClear,
      showError,
      error,
      expandedPlaceholder,
      placeholder,
      expandedPlaceholderId,
      placeholderId,
      allowTyping,
      showClear,
      optionsClassName
    } = this.props;
    const {
      showOptions
    } = this.state;
    let isAbove;
    if (this.containerRef.current) {
      isAbove = window.innerHeight - this.containerRef.current?.getBoundingClientRect().bottom < MAX_DROPDOWN_HEIGHT;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.containerRef,
      className: (0, _classnames.default)(styles.container, className),
      "data-testid": "multi-dropdown",
      tabIndex: 0,
      onBlur: () => this.setState({
        showOptions: false
      })
    }, /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      value: selection,
      onChange: event => this.onChange(event.target.value),
      onKeyDown: e => (0, _includes.default)(INTERACTIVE_KEYS).call(INTERACTIVE_KEYS, e.key) ? this.onInteractiveKey(e) : _constants.NOOP,
      onClear: onClear,
      showError: showError,
      error: error,
      placeholder: showOptions && expandedPlaceholder || placeholder,
      placeholderId: showOptions && expandedPlaceholderId || placeholderId,
      showClear: showClear,
      onClick: allowTyping ? _constants.NOOP : () => this.expandDropdown(),
      readOnly: !allowTyping,
      createMode: !createMode
    }), !allowTyping && /*#__PURE__*/_react.default.createElement("span", {
      className: styles.toggle
    }), !allowTyping && showOptions && /*#__PURE__*/_react.default.createElement(OptionList, {
      showOptions: showOptions,
      options: this.props.options,
      selectedIndex: this.state.selectedIndex,
      expandedOptionIndex: this.state.expandedOptionIndex,
      expandOptionGroup: this.expandOptionGroup,
      selectOption: this.selectOption,
      className: (0, _classnames.default)({
        [styles.above]: isAbove
      }),
      optionsClassName: optionsClassName
    }), allowTyping && selection.length !== 0 && showOptions && /*#__PURE__*/_react.default.createElement(OptionList, {
      showOptions: showOptions,
      options: this.props.options,
      selectedIndex: this.state.selectedIndex,
      expandedOptionIndex: this.state.expandedOptionIndex,
      expandOptionGroup: this.expandOptionGroup,
      selectOption: this.selectOption,
      optionsClassName: optionsClassName,
      className: className
    }));
  }
}
exports.default = MultiDropDown;
class OptionList extends _react.default.Component {
  static propTypes = {
    options: MultiDropDown.propTypes.options,
    selectedIndex: T.number,
    expandedOptionIndex: T.number,
    expandOptionGroup: T.func,
    selectOption: T.func,
    className: T.string,
    optionsClassName: T.string,
    maxOptionsShown: T.number
  };
  static defaultProps = {
    maxOptionsShown: 7
  };
  render() {
    const {
      options,
      selectedIndex,
      expandedOptionIndex,
      expandOptionGroup,
      selectOption,
      showOptions,
      className,
      optionsClassName,
      maxOptionsShown
    } = this.props;
    let totalIndex = 0;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.options, className, optionsClassName, {
        [styles.hide_options]: !showOptions
      }),
      onMouseDown: e => e.preventDefault()
    }, (0, _map.default)(options).call(options, (optionGroup, optionGroupIndex) => {
      var _context5;
      return Boolean(optionGroup.options.length) && /*#__PURE__*/_react.default.createElement("div", {
        key: optionGroup.displayId ?? optionGroup.displayString,
        className: styles.option_group
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        id: selectedIndex === totalIndex ? SELECTED : null,
        className: (0, _classnames.default)(styles.option_header, {
          [styles.expanded]: expandedOptionIndex === optionGroupIndex,
          [styles.selected]: selectedIndex === totalIndex++ //index is being incremented here to create a running counter of items
        }),

        displayId: optionGroup.displayId,
        displayString: optionGroup.displayString,
        values: {
          count: optionGroup.options.length
        },
        onClick: () => expandOptionGroup(optionGroupIndex),
        tag: "div"
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.group_options_wrapper, {
          [styles.group_expanded]: expandedOptionIndex === optionGroupIndex,
          [styles.hide_scrollbar]: optionGroup.options.length <= maxOptionsShown
        })
      }, expandedOptionIndex === optionGroupIndex && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _map.default)(_context5 = optionGroup.options).call(_context5, option => /*#__PURE__*/_react.default.createElement("div", {
        key: optionGroup.displayId + ":" + option.val,
        id: selectedIndex === totalIndex ? SELECTED : null,
        className: (0, _classnames.default)(styles.option, {
          [styles.selected]: selectedIndex === totalIndex++ //index is being incremented here to create a running counter of items
        }),

        onClick: () => selectOption(option.val, optionGroup)
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: option.displayId,
        displayString: option.displayString
      })))))));
    }));
  }
}